module.exports = __webpack_public_path__ + "static/excellent-customer-service-e4187a5b201f492241e75611346602a6.png";